<script setup>
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
  
</script>

<template>
  <div class="row">
    <jumbo title="Introduction">
The (REST) API provided by our platform offers a straightforward and efficient way to interact with our services programmatically.
    </jumbo>
  </div>
</template>


<style scoped>
</style>
